import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  position: relative;
`;

const Overlay = styled.div`
  position: ${(props) => (props.$contained ? "absolute" : "fixed")};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${(props) =>
    props.$contained ? "transparent" : "rgba(0, 0, 0, 0.35)"};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
`;

const Spinner = styled.div`
  border: 8px solid
    ${(props) =>
      props.$contained ? "rgba(0, 0, 0, 0.15)" : "rgba(255, 255, 255, 0.4)"};
  border-top: 8px solid ${(props) => (props.$contained ? "#555" : "#fff")};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
`;

const LoadingWrapper = ({ loading, contained = false, children }) => {
  return (
    <Wrapper>
      {loading && (
        <Overlay $contained={contained}>
          <Spinner $contained={contained} />
        </Overlay>
      )}
      {children}
    </Wrapper>
  );
};

export default LoadingWrapper;
